export const SET_HUMAN_CONTACT = "SET_HUMAN_CONTACT";

export function setHumanContact({ humanId, type, value }) {
  return {
    type: SET_HUMAN_CONTACT,
    id: `${humanId}_${type}`,
    humanId,
    value,
    valueType: type,
  };
}
